export interface IStrings  {
  required: string
  ds_ins: string
  ds_copy: string
  ds_edit: string
  ds_del: string
  row: string
  btn_ok: string
  btn_cancel: string
}

interface IStringsObj  {
  [key: string]: IStrings,
}

export const stringsObj: IStringsObj = {
  en: {
    required: 'Input required',
    ds_ins: 'Add Row',
    ds_copy: 'Copy Row',
    ds_edit: 'Edit Row',
    ds_del: 'Delete Row',
    row: 'Row Nr.',
    btn_ok: 'OK',
    btn_cancel: 'Cancel',
  },
  de: {
    required: 'Eingabe erforderlich',
    ds_ins: 'Datensatz einfügen',
    ds_copy: 'Datensatz kopieren',
    ds_edit: 'Datensatz bearbeiten',
    ds_del: 'Datensatz löschen',
    row: 'Zeile Nr.',
    btn_ok: 'OK',
    btn_cancel: 'Abbrechen',
  },
  fr: {
    required: 'Entrée requise',
    ds_ins: "Insérer un enregistrement de données",
    ds_copy: "Copier l'enregistrement de données",
    ds_edit: "Modifier l'enregistrement",
    ds_del: "Supprimer l'ensemble de données",
    row: 'Ligne No.',
    btn_ok: 'OK',
    btn_cancel: 'Annuler',
  },
  it: {
    required: "Ingresso richiesto",
    ds_ins: 'Inserisci record di dati',
    ds_copy: 'Copia record di dati',
    ds_edit: 'Modifica record',
    ds_del: "Elimina set di dati",
    row: "Riga n.",
    btn_ok: 'OK',
    btn_cancel: 'Annulla',
 },

}